//Word Count & Goals
export const CHANGE_WORDCOUNT = 'CHANGE_WORDCOUNT'
export const CHANGE_CHARCOUNT = 'CHANGE_CHARCOUNT'
export const GOAL_REACHED = 'GOAL_REACHED'
export const CHANGE_GOAL = 'CHANGE_GOAL'
export const TOGGLE_EDIT_GOAL = 'TOGGLE_EDIT_GOAL'
export const SET_NEW_GOAL = 'SET_NEW_GOAL'
export const SET_NEW_GOAL_ERROR = 'SET_NEW_GOAL_ERROR'

// Alerts
export const SET_ALERT = 'SET_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

//Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const USER_LOADED = 'USER_LOADED'
export const TOGGLE_GUEST_MODE = 'TOGGLE_GUEST_MODE'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'

// Journal Entries stuff
export const SET_ENTRY = 'SET_ENTRY'
export const SAVE_ENTRY = 'SAVE_ENTRY'
export const DELETE_ENTRY = 'DELETE_ENTRY'
export const ENTRIES_ERROR = 'ENTRIES_ERROR'

// Journal Config stuff
export const GET_JOURNAL_ENTRIES = 'GET_JOURNAL_ENTRIES'
export const SET_JOURNAL_CONFIG = 'SET_JOURNAL_CONFIG'
export const UPDATE_JOURNAL_CONFIG = 'UPDATE_JOURNAL_CONFIG'

//Timer
export const SET_TIME_ELAPSED = 'SET_TIME_ELAPSED'
export const TOGGLE_TIMER_ACTIVE = 'TOGGLE_TIMER_ACTIVE'

//Prompts Stuff
export const ADD_CUSTOM_PROMPT = 'ADD_CUSTOM_PROMPT'
export const DELETE_CUSTOM_PROMPT = 'DELETE_CUSTOM_PROMPT'
export const CUSTOM_PROMPT_ERROR = 'CUSTOM_PROMPT_ERROR'
export const TOGGLE_CUSTOM_PROMPTS_ENABLED = 'TOGGLE_CUSTOM_PROMPTS_ENABLED'

//Tracked Phrases
export const ADD_TRACKED_PHRASE = 'ADD_TRACKED_PHRASE'
export const DELETE_TRACKED_PHRASE = 'DELETE_TRACKED_PHRASE'

//Modals
export const OPEN_SUCCESS_MODAL = 'OPEN_SUCCESS_MODAL'
export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL'
export const OPEN_SAVE_ENTRY_MODAL = 'OPEN_SAVE_ENTRY_MODAL'
export const CLOSE_SAVE_ENTRY_MODAL = 'CLOSE_SAVE_ENTRY_MODAL'
export const OPEN_INTRO_MODAL = 'OPEN_INTRO_MODAL'
export const CLOSE_INTRO_MODAL = 'CLOSE_INTRO_MODAL'
export const TOGGLE_GUEST_MODE_MODAL_SEEN = 'TOGGLE_GUEST_MODE_MODAL_SEEN'

//User Days ETC
export const INCREASE_DAYS = 'INCREASE_DAYS'
export const DAY_INCREASE_ERROR = 'DAY_INCREASE_ERROR'
export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN'
export const TOGGLE_PROGRESS_AUDIO = 'TOGGLE_PROGRESS_AUDIO'

//Modes
export const CHANGE_MODE = 'CHANGE_MODE'

//Contact
export const SUBMIT_CONTACT_FORM = 'SUBMIT_CONTACT_FORM'
export const CONTACT_FORM_ERROR = 'CONTACT_FORM_ERROR'

//Prompts
export const SHUFFLE_PROMPT = 'SHUFFLE_PROMPT'
